import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Typography, 
  Button,
  Paper
} from '@mui/material';
import { Home as HomeIcon, Error as ErrorIcon } from '@mui/icons-material';

function NotFound() {
  return (
    <Paper 
      elevation={0}
      sx={{ 
        p: 6,
        borderRadius: 5,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: '400px',
        boxShadow: '0 30px 60px rgba(0,0,0,0.15)',
        border: '1px solid rgba(255, 255, 255, 0.3)'
      }}
    >
      <ErrorIcon 
        sx={{ 
          fontSize: '4rem', 
          color: '#ff6b6b', 
          mb: 2,
          opacity: 0.8
        }} 
      />
      
      <Typography 
        variant="h1" 
        sx={{ 
          background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: 900,
          fontSize: { xs: '4rem', sm: '6rem' },
          letterSpacing: '-0.02em',
          fontFamily: '"Inter", "Roboto", sans-serif',
          lineHeight: 1,
          mb: 2
        }}
      >
        404
      </Typography>
      
      <Typography 
        variant="h4" 
        sx={{ 
          color: 'rgba(0, 0, 0, 0.8)',
          fontWeight: 600,
          fontSize: { xs: '1.5rem', sm: '2rem' },
          mb: 1
        }}
      >
        Stránka nenalezena
      </Typography>
      
      <Typography 
        variant="body1" 
        sx={{ 
          color: 'rgba(0, 0, 0, 0.6)',
          fontSize: '1.1rem',
          mb: 4,
          maxWidth: '400px'
        }}
      >
        Omlouváme se, ale stránka, kterou hledáte, neexistuje nebo byla přesunuta.
      </Typography>
      
      <Button
        component={RouterLink}
        to="/"
        variant="contained"
        startIcon={<HomeIcon />}
        sx={{
          borderRadius: 50,
          px: 4,
          py: 1.5,
          fontWeight: 'bold',
          textTransform: 'none',
          fontSize: '1.1rem',
          background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
          boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)',
          '&:hover': {
            background: 'linear-gradient(135deg, #ff5252 0%, #e53e3e 100%)',
            boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
            transform: 'translateY(-1px)',
          }
        }}
      >
        Zpět na hlavní stránku
      </Button>
    </Paper>
  );
}

export default NotFound; 